import { render } from "./PersonSectionNavigator.vue?vue&type=template&id=a4737c3c&scoped=true"
import script from "./PersonSectionNavigator.vue?vue&type=script&lang=js"
export * from "./PersonSectionNavigator.vue?vue&type=script&lang=js"

import "./PersonSectionNavigator.vue?vue&type=style&index=0&id=a4737c3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4737c3c"]])

export default __exports__